import NumberAnimate from '../NumberAnimate/NumberAnimate'
import DesFemmes1 from './SVGJS/DesFemmes1'
import DesFemmes2 from './SVGJS/DesFemmes2'
// import Immeubles1 from "./SVGJS/Immeubles1";
import Immeubles2 from './SVGJS/Immeubles2'
import Immeubles3 from './SVGJS/Immeubles3'
import Immeubles4 from './SVGJS/Immeubles4'
import Immeubles5 from './SVGJS/Immeubles5'
import Promouvoir1 from './SVGJS/Promouvoir1'
import Promouvoir3 from './SVGJS/Promouvoir3'
import Promouvoir4 from './SVGJS/Promouvoir4'
import Promouvoir5 from './SVGJS/Promouvoir5'
import Promouvoir6 from './SVGJS/Promouvoir6'

const ChiffresCles = (isVisible) => {
	return (
		<>
			<article className="container">
				<div className="row">
					<div className="column dataviz col-md-6">
						<h3>
							3<sup>ème</sup> bailleur social
						</h3>
					</div>
					<div className="column dataviz col-md-6 ">
						<DesFemmes1 />
					</div>
				</div>
			</article>
			<article className="container promouvoir1">
				<div className="row ">
					<div className="column dataviz col-md-6">
						<Promouvoir1 />
					</div>
					<div className="column col-md-6">
						<h3>
							<NumberAnimate nb={29268} />
							Logements gérés
						</h3>
						<p className="mt-6">
							<b>Ce patrimoine est réparti :</b>{' '}
							<ul>
								<li>
									Paris
									<br />
									<b>24 123 (82 %)</b>
								</li>
								<li>
									Banlieue
									<br />
									<b>5 145 (18 %)</b>.
								</li>
							</ul>
						</p>
					</div>
				</div>
			</article>

			<article className="container">
				<div className="row desfemmes1 is-vcentered">
					<div className="column text col-md-6 columns ">
						<h3>
							<p>Collaborateurs</p>
							<NumberAnimate nb={502} />
						</h3>
					</div>
					<div className="column dataviz col-md-6">
						<DesFemmes2 />
					</div>
				</div>
			</article>
			<article className="container immeubles2 ">
				<h3>
					<p>Logements attribués dans l'année</p>
				</h3>
				<Immeubles2 />
			</article>
			<article className="container">
				<h3>
					<p>Répartitions des logements familiaux</p>
				</h3>
				<div className="row ">
					<div className="column  col-md-6">
						<Immeubles3 />
					</div>
					<div className="column  col-md-6 ">
						<Immeubles4 />
					</div>
				</div>
			</article>
			<article className="container immeubles5 ">
				<div className="row pt-5  is-vcentered">
					<div className="column dataviz col-md-6 ">
						<Immeubles5 />
					</div>
					<div className="column dataviz col-md-6 is-flex is-justify-content-center ">
						<h3 className="is-inline">Locaux d'activité</h3>{' '}
					</div>
				</div>
			</article>
			<article className="container promouvoir3 ">
				<div className="row is-vcentered has-text-centered">
					<div className="column column1 col-md-6">
						<h3>Entretien</h3>
					</div>
					<div className="column dataviz col-md-6 ">
						<Promouvoir3 />
					</div>
				</div>
			</article>
			<article className="container promouvoir4-5">
				<h3 className=" ">Livraison</h3>
				<div className="row ">
					<div className="column column1 dataviz col-md-6 ">
						<Promouvoir4 />
					</div>
					<div className="column column2 col-md-6">
						<Promouvoir5 />
					</div>
				</div>
			</article>
			<article className="container promouvoir6">
				<div className="row is-multiline ">
					<div className="column col-12">
						<Promouvoir6 />
					</div>
				</div>
			</article>
		</>
	)
}
export default ChiffresCles
